module.exports = __webpack_public_path__ + "img/user.6da81c90.svg";